import React, { Component } from "react";
import Fade from "react-reveal";

class About extends Component {
  render() {
    if (!this.props.data) return null;
    const profilepic = "images/" + this.props.data.image;
    const profilepic1 = "images/" + this.props.data.image1;
    const profilepic2 = "images/" + this.props.data.image2;
    const profilepic3 = "images/" + this.props.data.image3;
    const bio = this.props.data.bio;
    return (
      <section id="about">
        <Fade duration={1000}>
          <div className="row">
            <div className="three columns">
              <img
                className="profile-pic"
                src={profilepic}
                alt="Nordic Giant Profile Pic"
              />
              <img
                className="profile-pic"
                src={profilepic1}
                alt="Nordic Giant Profile Pic"
              />
              <img
                className="profile-pic"
                src={profilepic2}
                alt="Nordic Giant Profile Pic"
              />
              <img
                className="profile-pic"
                src={profilepic3}
                alt="Nordic Giant Profile Pic"
              />
            </div>
            <div className="nine columns main-col">
              <h2>Introduction</h2>

              <p>{bio}</p>
              <div className="row">
                <div className="columns contact-details">
                  <h2>Members of the F4Kingsman</h2>
                  <p className="address">
                    <span>Soravit Satechaichan</span>
                    <br />
                    <span>Punawat Kovitkoolkri
                      <br />
                    </span>
                    <span>Jirapat Kongkatonyoosakul</span>
                    <br />
                    <span>Jirapat Thongpiyapoom</span>
                  </p>
                </div>
                <div className="columns download">
                </div>
              </div>
            </div>
          </div>
        </Fade>
      </section>
    );
  }
}

export default About;
